
import $ from "jquery"

import StickyNavbarHandler from "app/sticky_navbar_handler/index"


const SELECTOR = ".js-scrollspy-navbar"


const onLoad = () => {
  const $window = $(window)

  $(`${SELECTOR} li > a`).each((_idx, element) => {
    const $this = $(element)
    const $target = $($this.attr("href") as string)

    if (!$target.length) {
      return
    }

    $window.on("scroll touchmove", () => {
      let extraOffset = 60
      extraOffset += StickyNavbarHandler.getTotalOffsetForScrolling()

      const target_offset = $target.offset()
      if (target_offset == null) { return }

      if ( ($window.scrollTop() || 0) > (target_offset.top - extraOffset)) {
        $(`${SELECTOR} li`).removeClass("active")
        $this.parent("li").addClass("active")
      }
    })
  })

  // First thing should have active class on start
  $(`${SELECTOR} li:first-child`).addClass("active")
}


export default {
  onLoad: onLoad,
}
